import { useIntl } from 'react-intl';
import { Account } from '@/features/accounts/types';
import { useModalState } from '@/shared/hooks';
import Modal from './Modal';

interface Props {
  account: Account;
}

export default function Button({ account }: Props) {
  const intl = useIntl();
  const { isOpen, open, close } = useModalState();

  return (
    <>
      <button
        type="button"
        onClick={open}
        className="p-1.5 rounded text-slate-400 hover:bg-brand-50 hover:text-brand-600 transition"
        aria-label={intl.formatMessage({ id: 'accounts.editPassword.action' })}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path d="M2 6a2 2 0 012-2h5a1 1 0 010 2H4v10h10v-5a1 1 0 112 0v5a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
          <path d="M14.586 2.586a2 2 0 112.828 2.828l-7.793 7.793a1 1 0 01-.39.242l-3 1a1 1 0 01-1.266-1.265l1-3a1 1 0 01.242-.391l7.793-7.793-.414-.414z" />
        </svg>
      </button>
      <Modal account={account} isOpen={isOpen} onClose={close} />
    </>
  );
}
